export default __webpack_public_path__ + "static/media/twitter_bg_white_color_black.a6b70275.svg";